// prettier-ignore
export default "2025.0617.1224"